export function replace(data) {
	return {
		type: 'replace',
		data: data
	}
}